const PUBMED_RX = /^.+\s([A-Z]\.?(\s|-)?){1,2}$/;
export function parseAuthors(val) {
    return val
        .split(',')
        .map(author => getAuthorParts(author).join(' '));
}
export function authorsToParts(val) {
    return val
        .split(',')
        .map(getAuthorParts);
}
export function getAuthorParts(author) {
    author = author.trim();
    const parts = author.split(/\s+/);
    const reverse = PUBMED_RX.test(author);
    if (reverse) {
        let last = parts[parts.push(parts.shift() || '') - 1];
        while (/^(al|von|del?)$/i.test(last)) {
            last = parts[parts.push(parts.shift() || '') - 1];
        }
    }
    return parts;
}
